import { render, staticRenderFns } from "./InsuranceAuthorizationInsuranceSelection.vue?vue&type=template&id=6628cef3&"
import script from "./InsuranceAuthorizationInsuranceSelection.vue?vue&type=script&lang=js&"
export * from "./InsuranceAuthorizationInsuranceSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports